import { Cleanable } from './types';

const isDate = (value: unknown): value is Date => {
  return value instanceof Date;
};

const isEmptyObject = (value: unknown): value is Record<string, unknown> => {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    !isDate(value) &&
    Object.keys(value).length === 0
  );
};

const isEmptyArray = (value: unknown): value is unknown[] => {
  return Array.isArray(value) && value.length === 0;
};

const isRemovableValue = (value: unknown): boolean => {
  return (
    value === null ||
    value === undefined ||
    value === '' ||
    isEmptyArray(value) ||
    isEmptyObject(value)
  );
};

export const cleanObject = <T extends Cleanable>(value: T): T | undefined => {
  if (Array.isArray(value)) {
    const cleaned = value
      .map((item) => cleanObject(item))
      .filter((item): item is Cleanable => !isRemovableValue(item));

    return cleaned as T;
  }

  if (isDate(value)) {
    return value;
  }

  if (typeof value === 'object' && value !== null) {
    const result: Record<string, Cleanable> = {};
    const recordValue = value as Record<string, Cleanable>;

    for (const [key, nestedValue] of Object.entries(recordValue)) {
      const cleanedValue = cleanObject(nestedValue);

      if (isRemovableValue(cleanedValue)) continue;

      result[key] = cleanedValue;
    }

    return result as T;
  }

  return value;
};
